import { WedgeRewardType } from "./WedgeRewardType";

export class WedgeRewardData {
    public readonly type: WedgeRewardType;
    public readonly count: number;

    public constructor(type: WedgeRewardType, count: number) {
        this.type = type;
        this.count = count;
    }
}
